<template>
  <div class="no-existing-resource has-text-centered">
    <div class="columns">
      <div class="column">
        <article class="message header">
          <div class="message-body logo-header">
            <img
              v-if="$store.state.logos.length"
              :src="$store.state.logos[1]"
            >
            <img
              v-else
              src="../../assets/white-logo.png"
              alt="webdotcom"
            >
            <span class="heading"><slot name="title" /></span>
          </div>
        </article>
      </div>
    </div>
    <div
      v-show="showContent"
    >
      <div class="columns mb-0">
        <div class="column pt-0">
          <article class="message explanation">
            <div class="message-body">
              <p><slot name="explanation" /></p>
            </div>
          </article>
        </div>
      </div>
      <slot />
      <div class="columns mt-0">
        <div class="column pt-0">
          <article class="message resolution">
            <div class="message-body">
              <p><slot name="resolution" /></p>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NoExistingResource',
  props: {
    showContent: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
.mt-0 {
  margin-top: 0px;
}
.mb-0 {
  margin-bottom: 0px;
}
.pt-0 {
  padding-top: 0px;
}
.pb-0 {
  padding-bottom: 0px;
}
.no-existing-resource {
  // background-image: url('../../assets/waves-kv-1.png');
  // background-position: center 0px;
  .header {
    background: var(--tertiary-color);
    border-radius: 0px;

    .heading {
      font-size: 18px;
      margin-top: 10px;
      color: var(--base-white);
    }
  }

  .explanation {
    background: var(--tertiary-color);
    margin-bottom: 0px;
    border-radius: 0px;

    p {
      color: var(--base-white);
    }
  }

  .resolution {
    background: var(--base-grey-light);
    border-radius: 0px;
  }
}
.logo-header {
  img {
    max-width: 220px;
  }
}
.message {
  font-size: 2rem;

  .message-body {
    border-style: none;
  }
}

</style>
